
<template>
  <div style="padding-top: 100px">
    <button @click="getLocation">获取</button>
    <span>{{ location }}</span>
  </div>
</template>

<script>
export default {
  data() {
    return {
      location: "",
    };
  },
  mounted() {
    window.setLocation = this.setLocation;
  },
  methods: {
    getLocation() {
      this.params(null, null, "getLocation");
    },
    setLocation(e) {
      this.location = JSON.stringify(e);
    },
  },
};
</script>

<style>
</style>